import React from "react";
import styles from "./Header.module.scss";
import HeaderSlider from "../HeaderSlider/HeaderSlider";

// Визначаємо тип для пропсів компонента Header
interface SliderImage {
  src1920: string; // Зображення для 1920px
  src1440: string; // Зображення для 1440px
  src768: string; // Зображення для 768px
  src320: string; // Зображення для 320px
  alt: string; // Опис зображення
  imageType?: "full" | "partial"; // Тип зображення (необов'язковий, за замовчуванням full)
}

interface HeaderProps {
  images: SliderImage[]; // Масив зображень
}

const Header: React.FC<HeaderProps> = ({ images }) => {
  // За замовчуванням додаємо imageType: "full" для кожного зображення
  const updatedImages = images.map((image) => ({
    ...image,
    imageType: image.imageType || "full", // Якщо imageType не передано, встановлюємо "full"
  }));

  return (
    <header className={styles.header}>
      {/* Передаємо пропс images в HeaderSlider */}
      <HeaderSlider images={updatedImages} />
    </header>
  );
};

export default Header;
